import type { initRepaint } from './repaint-canvas';
import { makeAutoObservable } from 'mobx';

export const basicRepaintForm = {
  brushType: '涂抹',
  brushSize: 24,
  prompt: '',
  generate_nums: 1,
  width: 0,
  height: 0,
  refer_img: '',
};
export const basicRepaintConfig = {
  bg: 'transparent',
  color: 'rgba(0, 106, 255, 0.5)',
  gradientColor: 'rgba(255, 255, 255, 0.5)', // 修改渐变色第二个颜色
  useGradient: true, // 是否使用渐变色
  gradientType: 'linear', // 渐变类型：linear或radial
  gradientDirection: 'to right', // 线性渐变方向
  draw: 24,
  hideCursor: true,
  shape: 'rect',
  bgType: '',
};
class Store {
  constructor() {
    makeAutoObservable(this);
  }
  repaintForm = {
    ...basicRepaintForm,
  };
  repaintConfig = {
    ...basicRepaintConfig,
  };
  result: null | any = null;
  repaintDoodle: ReturnType<typeof initRepaint> | undefined;
  loading = false;
  setLoading = data => {
    this.loading = data;
  };
  setResult = data => {
    this.result = data;
  };
  setRepaintForm = data => {
    this.repaintForm = { ...this.repaintForm, ...data };
  };
  setRepaintConfig = data => {
    this.repaintConfig = { ...this.repaintConfig, ...data };
  };
  setRepaintDoodle = data => {
    this.repaintDoodle = data;
  }
}

// 确保导出的是实例而不是类
export const RepaintCanvasStore = new Store();
